import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { isIOSWebView } from "../../../utils/helpers";

const iosStyleContainer = {
  justifyContent: "space-between",
  alignItems: "center",
};

const iosStyleTitle = {
  marginBottom: 0,
};

const iosStyleIcon = {
  width: 40,
};

const PaymentMethodItem = ({ title, text, icon, onClick }) => {
  PaymentMethodItem.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
  };
  return (
    <div
      style={isIOSWebView() ? iosStyleContainer : null}
      className="payment_method_item"
      onClick={onClick}
    >
      <div className="payment_method_item__text">
        <p
          style={isIOSWebView() ? iosStyleTitle : null}
          className="payment_method_item__text--title"
        >
          {title}
        </p>
        {!isIOSWebView() && <p>{text}</p>}
      </div>
      <div className="payment_method_item__img">
        <img src={icon} style={isIOSWebView() ? iosStyleIcon : null} alt="" />
      </div>
    </div>
  );
};

export default PaymentMethodItem;
